import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'hooks/use-search-params.hook';
import qs from 'qs';
import { replace } from 'store/router/actions';

export const useClearFilters = () => {
  const {
    filterByType,
    filterByCollection,
    startDate,
    startTime,
    endTime,
    duration,
    isExact,
    capacity,
    presetWindows,
    filterByFloor,
    startDates,
    availableNow,
    ...restQueryParams
  } = useSearchParams();
  const dispatch = useDispatch();

  return useCallback(() => {
    if (
      !filterByType &&
      !filterByCollection &&
      !startDate &&
      !startTime &&
      !endTime &&
      !duration &&
      !isExact &&
      !capacity &&
      !presetWindows &&
      !filterByFloor &&
      !startDates &&
      !availableNow
    ) {
      return;
    }
    const queryString = qs.stringify(restQueryParams);

    dispatch(replace(`${location.pathname}?${queryString}`));
  }, [
    filterByType,
    filterByCollection,
    startDate,
    startTime,
    endTime,
    duration,
    isExact,
    capacity,
    presetWindows,
    filterByFloor,
    startDates,
    availableNow,
    restQueryParams,
    dispatch,
  ]);
};
